<template>
          <div class="bg-white rounded-t-3xl pt-14 -mt-14 flex-1 pb-32 dark:bg-n0">
        <div class="px-6 pt-8">
          <a href="https://softivuspro.com/html/bankux/main-demo/bill-pay.html" class="bg-g300 rounded-2xl py-5 px-6 flex justify-between items-center">
            <div class="w-1/2">
              <p class="text-white text-xl font-semibold">
                List Karyawan
              </p>
              <br />
             <router-link to="/register"  class="text-sm px-4 py-2 rounded-md bg-o300 text-white pt-2">          
            
             tambah
             
         </router-link> 
             
            </div>
            <div class="">
              <img src="../../public/asset/pay-bill-illus.png" alt="">
            </div>
          </a>
        </div>
        <div class="px-6 pt-8">
          <div class="flex justify-between items-center">
            
            <a href="#" class="text-g300 font-semibold text-sm">
              View All</a>
          </div>
          <div class="flex flex-col gap-4 pt-6">
                     <pulse-loader :loading="dataload" :color="color" :size="size" style="position: absolute; top: 50%;right: 45%;"></pulse-loader>
 
            <div  v-for="item in items" :key="item.id" href="#" class="flex justify-between items-center border-b border-dashed border-n40 dark:border-darkN40 pb-4">
              <div class="flex justify-start items-center gap-4">
                <div class="rounded-full bg-bgColor2 dark:bg-darkN40 overflow-hidden">
                  <img src="../../public/asset/people-2.png" alt="" class="w-[60px] h-[60px] object-cover">
                </div>
                <div class="">
                  <p class="font-semibold">{{ item.name }}</p>
                  <p class="text-n500 dark:text-darkN500 text-xs pt-2.5">
                    {{item.jabatan}}
                  </p>
                </div>
              </div>
                <router-link :to="'/edit/' + item.id "  class="flex flex-col justify-end items-end">
                
                <p class="text-red-500 text-xs py-0.5 px-2 bg-red-200 rounded-md dark:bg-darkN40">
                  Edit
                </p>
              </router-link> 
            </div>
       
    
          </div>
        </div>
      </div>
       <NavAdmin  ></NavAdmin>
</template>
 
<script setup>

import { onMounted,ref} from 'vue'
import { useRoute } from 'vue-router'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import NavAdmin from '../components/NavAdmin.vue'



const route = useRoute()
const items = ref([])
const dataload = ref(true)

console.log(route.params.id)

onMounted(async () => { 

  const token = localStorage.getItem("token");

  const res = await fetch("https://kiyanrahayu.my.id/api2/getuser"   ,{
      headers: {         
        "Authorization": "Bearer " + token,
         "Accept": "application/json"
       }
    })

 if(res.ok){

      const dt = await res.json()    
      items.value = dt.data  

      dataload.value = false
 
 }


})

</script>